import React, { Fragment } from "react"
import { CARD_STACK_PROPS } from "./interface"

import { CardComponent } from "components/card/Card"
import { useCard } from "@orbitalgaming/games-frontend-library"
import {
  SuitStyled,
  CardWrapper,
  SideSymbols,
  CardContainer,
} from "components/card/CardStyled"

import { handleBackgroudColor } from "./helper"
import { colors } from "lib/colors"

export default function Cards({
  cards,
  deal,
  isGameActive,
  result,
  name,
  bankerLength,
  win,
  showResult,
  dealOut,
}: CARD_STACK_PROPS): JSX.Element {
  const { handleCardSymbol, handleCardColor, handleCardSuit } = useCard()

  const calculateDelay = (i: number, length: number | undefined) => {
    switch (i) {
      case 0:
        return name === "banker" ? 0 : 0.4
      case 1:
        return name === "banker" ? 0.8 : 1.2
      case 2:
        return name === "banker" || length === 2 ? 2.6 : 3
      default:
        break
    }
  }

  const helperCardColor = (card: string, result: boolean | undefined) => {
    return handleCardColor(
      card,
      result ? "#e7e2de" : colors.secondaryText,
      result ? "#e7e2de" : colors.secondaryBackground,
    )
  }
  return (
    <Fragment>
      {cards?.map((card: string, i: number) => (
        <CardContainer
          key={i}
          left={(i * 23).toString()}
          bot={(i * -28).toString()}
        >
          <CardWrapper
            deal={deal}
            animDelay={calculateDelay(i, bankerLength)}
            background={handleBackgroudColor(showResult, result, win)}
            suitColor={helperCardColor(card, showResult)}
          >
            <CardComponent
              deal={deal}
              dealOut={dealOut}
              isGameActive={isGameActive}
              name={name}
              background={handleBackgroudColor(showResult, result, win)}
              suitColor={helperCardColor(card, showResult)}
              showResult={showResult}
              win={win}
            >
              <SideSymbols>
                <p>{handleCardSymbol(card)}</p>
                <SuitStyled suitSize='15px' left='8px' top='30px'>
                  {handleCardSuit(card)}
                </SuitStyled>
              </SideSymbols>
              <SuitStyled>{handleCardSuit(card)}</SuitStyled>
            </CardComponent>
          </CardWrapper>
        </CardContainer>
      ))}
    </Fragment>
  )
}
